// Pure builder for the submissions insert payload (shared shape with offline queue).
export const buildSubmissionPayload = ({ clientId, activeCompanyId, tpl, locationId, loc, answers,
  quick, signoffs, user, profile, myWorker, revising, parentId, parentTitle, parentSectionId, parentSection, flagReasons }) => ({
  id: clientId, // client id makes submit idempotent (no duplicates on retry/double-flush)
  company_id: activeCompanyId,
  template_id: tpl.id,
  template_title: tpl.title,
  template_type: tpl.type,
  template_version: tpl.version,
  template_schema: tpl.schema,
  location_id: locationId,
  location_name: loc?.name || "Unknown",
  worker_id: myWorker?.id || null,
  worker_name: myWorker?.full_name || profile?.full_name || user.email,
  submitted_by: user.id,
  answers: quick.photos.length ? { ...answers, _qa_photos: quick.photos } : answers,
  quick_comments: quick.comments,
  status: "pending",
  completed_at: new Date().toISOString(),
  flagged: flagReasons.length > 0,
  flag_reasons: flagReasons,
  revision_of: revising?.id || null,
  revision: revising ? (revising.revision || 1) + 1 : 1,
  parent_submission_id: parentId || null,
  link_context: parentId ? { parent_title: parentTitle, section_id: parentSectionId || null, section_title: parentSection } : null,
  contractor_signoffs: signoffs,
  contractor_names: signoffs.length ? signoffs.map((s) => s.name) : null,
});
